import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { CellClickedEvent, GridOptions } from 'ag-grid';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { BtnsForGridService } from 'app/utils/btns-for-grid/btns-for-grid.service';
import { _currencyFormat } from 'app/utils/trip2-query-builder/utils/helpers';
import { Subscription } from 'rxjs';
import { BilledService } from '../billed.service';
import { GridLayoutStore, moduleActionIdOf } from 'app/utils/grid-layout-menu/grid-layout-store';

@Component({
  selector: 'app-summary-grid',
  templateUrl: './summary-grid.component.html',
  styleUrls: ['./summary-grid.component.scss']
})
export class SummaryGridComponent extends ParentModule implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];
  gridOptions: GridOptions;
  dataCurrentModule: any = {};
  constructor(
    private btnsForGridService: BtnsForGridService,
    private billedService: BilledService,
    protected Inject: Injector,
    private sweetAlertHelper: SweetAlertHelper,
    private layoutStore: GridLayoutStore,
  ) {
    super('app-billed', Inject);
    this.initGrid();
  }

  ngOnInit() {
    this.observables();
    this.initLayoutMenu();
  }

  observables() {
    this.subscriptions.push(
      this.btnsForGridService.clearFilterGrid$.subscribe((filter: string) => {
        if (filter && this.gridOptions.api) {
          const filterForGrid = {
            'filter': () => this.gridOptions.api.setFilterModel(null),
            'sort': () => this.gridOptions.api.setSortModel(null),
            'saveLayoutGrid': () => this.saveLayout()
          };
          return filterForGrid[filter]();
        }
      })
    );

    this.subscriptions.push(
      this.billedService.summaryData$.subscribe((data: any) => {
        if (data && this.gridOptions.api) {
          this.gridOptions.api.setRowData(data);
        }
      })
    );

    this.subscriptions.push(this.actions.asObservable().subscribe((res) => {
      if (res) {
        this.dataCurrentModule = res;
        this.getLayout();
      }
    }));

    this.subscriptions.push(
      this.actionsList$.subscribe(() => {
        this.disabledSaveLayout(this.isAllowedAction('SummaryGrig'));
      })
    );

    this.subscriptions.push(
      this.billedService.exporToExcel.subscribe((res: boolean) => {
        if (res && this.gridOptions.api) {
          this.gridOptions.api.exportDataAsExcel({ sheetName: 'summary', fileName: 'summary' });
        }
      })
    );
  }

  formatterAmountMoney = (params: any) => {
    const value = params && params.value ? params.value : 0;
    return _currencyFormat(value);
  }

  initGrid() {
    this.gridOptions = <GridOptions>{
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      groupIncludeTotalFooter: true,
      groupIncludeFooter: true,
      columnDefs: [
        {
          headerName: 'Payor',
          field: 'description',
          colId: 'payor-0',
          width: 450,
          cellRenderer: (params) => {
            if (params && !params.value) {
              return '<strong> Grand Total <strong>';
            }
            return params.value;
          },
          aggFunc: 'sum'
        },
        {
          headerName: '0 - 30',
          children: [
            {
              headerName: 'Trips',
              field: 'counttrips030',
              colId: 'trips-030',
              cellStyle: { textAlign: 'right' },
              cellRenderer: this.initTripsSum,
              aggFunc: 'sum'
            },
            {
              headerName: 'Amount',
              field: 'totalamount030',
              colId: 'amount-030',
              cellStyle: { textAlign: 'right' },
              cellRenderer: this.formatterAmountMoney,
              aggFunc: 'sum'
            }
          ]
        },
        {
          headerName: '31 - 60',
          children: [
            {
              headerName: 'Trips',
              field: 'counttrips3160',
              colId: 'trips-3160',
              cellStyle: { textAlign: 'right' },
              cellRenderer: this.initTripsSum,
              aggFunc: 'sum'
            },
            {
              headerName: 'Amount',
              field: 'totalamount3160',
              colId: 'amount-3160',
              cellStyle: { textAlign: 'right' },
              cellRenderer: this.formatterAmountMoney,
              aggFunc: 'sum'
            }
          ]
        },
        {
          headerName: '61 - 90',
          children: [
            {
              headerName: 'Trips',
              field: 'counttrips6190',
              colId: 'trips-6190',
              cellStyle: { textAlign: 'right' },
              cellRenderer: this.initTripsSum,
              aggFunc: 'sum'
            },
            {
              headerName: 'Amount',
              field: 'totalamount6190',
              colId: 'amount-6190',
              cellStyle: { textAlign: 'right' },
              cellRenderer: this.formatterAmountMoney,
              aggFunc: 'sum'
            }
          ]
        },
        {
          headerName: '91 - 120',
          children: [
            {
              headerName: 'Trips',
              field: 'counttrips91120',
              colId: 'trips-91120',
              cellStyle: { textAlign: 'right' },
              cellRenderer: this.initTripsSum,
              aggFunc: 'sum'
            },
            {
              headerName: 'Amount',
              field: 'totalamount91120',
              colId: 'amount-91120',
              cellStyle: { textAlign: 'right' },
              cellRenderer: this.formatterAmountMoney,
              aggFunc: 'sum'
            }
          ]
        },
        {
          headerName: 'Over 121 Days',
          children: [
            {
              headerName: 'Trips',
              field: 'counttrips121',
              colId: 'trips-121',
              cellStyle: { textAlign: 'right' },
              cellRenderer: this.initTripsSum,
              aggFunc: 'sum'
            },
            {
              headerName: 'Amount',
              field: 'totalamount121',
              colId: 'amount-121',
              cellStyle: { textAlign: 'right' },
              cellRenderer: this.formatterAmountMoney,
              aggFunc: 'sum'
            }
          ]
        },
        {
          headerName: 'Total',
          children: [
            {
              headerName: 'Trips',
              field: 'counttripstotals',
              cellStyle: { textAlign: 'right' },
              cellRenderer: this.initTripsSum,
              aggFunc: 'sum'
            },
            {
              headerName: 'Amount',
              field: 'totalamounttotals',
              cellStyle: { textAlign: 'right' },
              cellRenderer: this.formatterAmountMoney,
              aggFunc: 'sum'
            }
          ]
        }
      ],
      onGridReady: () => {
        this.gridOptions.api.setRowData([]);
        this.gridOptions.api.sizeColumnsToFit();
      },
      onFilterChanged: (params) => {
        if (params && params.api) {
          this.btnsForGridService.btnDisabled({ type: 'filter', disabled: params.api['filterManager'].advancedFilterPresent });
        }
      },
      onSortChanged: () => {
        const sort = this.gridOptions.api.getSortModel();
        this.btnsForGridService.btnDisabled({ type: 'sort', disabled: !!sort.length });
      },
      onCellDoubleClicked: (params: CellClickedEvent) => {
        if (params && params.data && params.colDef) {
          this.detailsSummary(params);
        }
      },
    };
  }

  detailsSummary(params) {
    if (params && params.data && params.colDef.colId) {
      const idCell = params.colDef.colId.split('-');
      const data = {
        payor: params.data.description,
        aging: idCell[1]
      };
      if (data && data.payor && data.aging) {
        this.billedService.sendDataFilter(data);
      }
    }
  }

  initTripsSum(params) {
    return params && params.value ? params.value : 0;
  }

  getLayout(): void {
    const moduleId = this.dataCurrentModule.moduleid;
    this.subscriptions.push(
      this.billedService.getRoleActionByModule(moduleId).subscribe(
        data => {
          data.forEach((val: any) => {
            if (val.action.description === 'SummaryGrig' && val.layout) {
              this.gridOptions.columnApi.setColumnState(JSON.parse(val.layout.config));
            }
          });
        }, (error) => {
          this.sweetAlertHelper.captureException(error).then(() => {
          });
        }
      ));
  }

  saveLayout(): void {
    if (this.gridOptions.columnApi.getColumnState().length) {
      const MODULE_ACTION_ID = this.dataCurrentModule.actions.SummaryGrig.moduleactionid;
      const stringLayout = JSON.stringify(this.gridOptions.columnApi.getColumnState());
      const data = { moduleactionid: MODULE_ACTION_ID, config: stringLayout };
      this.btnsForGridService.saveLayoutGrid(data);
    }
  }

  disabledSaveLayout(disabledBtn: boolean): void {
    this.btnsForGridService.btnDisabled({ type: 'layout', disabled: disabledBtn });
  }

  private initLayoutMenu() {
    this.subscriptions.push(this.layoutStore.follow(this.actionsList$, () => ({
      grid: this.gridOptions,
      moduleActionId: moduleActionIdOf(this.dataCurrentModule, 'SummaryGrig'),
      title: 'Billed Summary'
    })));
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/billed/summary-grid/summary-grid.component.ts